var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4372 1.55946C27.383 0.613644 28.9165 0.613644 29.8623 1.55946C30.8081 2.50527 30.8081 4.03874 29.8623 4.98455L18.8469 15.9999L29.8624 27.0154C30.8082 27.9612 30.8082 29.4947 29.8624 30.4405C28.9166 31.3863 27.3831 31.3863 26.4373 30.4405L15.4218 19.425L4.40643 30.4404C3.46062 31.3862 1.92715 31.3862 0.981333 30.4404C0.0355186 29.4946 0.03552 27.9611 0.981333 27.0153L11.9967 15.9999L0.981471 4.98466C0.0356573 4.03885 0.0356573 2.50538 0.981471 1.55956C1.92729 0.613749 3.46075 0.613749 4.40657 1.55956L15.4218 12.5748L26.4372 1.55946Z",
    fill: "url(#paint0_linear_4868_1180)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4868_1180",
    x1: 8.77012,
    y1: 30.4762,
    x2: 27.0485,
    y2: 13.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC400"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavClose);
export default __webpack_public_path__ + "static/media/nav_close.3fc39ed59aa3c7ef35eff17f73feb79e.svg";
export { ForwardRef as ReactComponent };